import { Heart, Leaf, Lightbulb, ShieldCheck, Sparkles } from "lucide-react"
import type { LucideIcon } from "lucide-react"

/**
 * OKS-383 — Catalog mapping for brand-authored value-card icons.
 *
 * The server stores/validates a small fixed set of `icon_key`s
 * (`Brand::CHARTER_VALUE_ICON_KEYS`); this is the FE side of that
 * contract — `icon_key` → Lucide glyph. Any unknown/blank key (the
 * server ships `null` for blank) returns `null` so the consumer renders
 * the ordinal "01/02/03" badge instead (PRD §3 / UX Spec §2.1).
 *
 * Keep this map in lock-step with `Brand::CHARTER_VALUE_ICON_KEYS` and
 * the `settings.brand.charter.values.icons.*` i18n labels.
 */
export const CHARTER_VALUE_ICONS: Record<string, LucideIcon> = {
  leaf: Leaf,
  "shield-check": ShieldCheck,
  lightbulb: Lightbulb,
  heart: Heart,
  sparkles: Sparkles,
}

/** The catalog keys, in display order — drives the editor's icon Select. */
export const CHARTER_VALUE_ICON_KEYS = Object.keys(CHARTER_VALUE_ICONS)

/**
 * Resolve an `icon_key` to its Lucide component, or `null` when the key
 * is absent/unknown (→ caller renders the ordinal badge).
 */
export function charterValueIcon(
  iconKey: string | null | undefined,
): LucideIcon | null {
  if (!iconKey) return null
  return CHARTER_VALUE_ICONS[iconKey] ?? null
}

/** Zero-padded ordinal badge label for a card index ("01" / "02" / "03"). */
export function charterValueOrdinal(index: number): string {
  return String(index + 1).padStart(2, "0")
}
